import React from 'react';
import TextFilter from './TextFilter';
export default function VirtualizedTableHeader(_ref) {
  let {
    columnData,
    // Additional data for the column
    dataKey,
    // Unique key associated with the column
    label,
    // header text
    sortDirection
  } = _ref;
  const {
    onClickHeader,
    onFilterByText,
    headerIndex,
    headerHeight,
    headerOverflow
  } = columnData;
  const renderSortableHeaderIcon = sortDirection => {
    if (!sortDirection) {
      return /*#__PURE__*/React.createElement("span", {
        className: "material-icons",
        onClick: () => {
          onClickHeader(headerIndex);
        }
      }, "sort");
    }
    return sortDirection === 'asc' ? /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      onClick: () => {
        onClickHeader(headerIndex);
      }
    }, "arrow_drop_up") : /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      onClick: () => {
        onClickHeader(headerIndex);
      }
    }, "arrow_drop_down");
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      height: headerHeight,
      overflow: headerOverflow
    }
  }, label, columnData.sortable && /*#__PURE__*/React.createElement("span", {
    // onClick={() => [handleSort(dataKey)]}
    style: {
      cursor: 'pointer'
    }
  }, renderSortableHeaderIcon(sortDirection)), columnData.filterableByText && /*#__PURE__*/React.createElement(TextFilter, {
    style: {
      position: 'absolute',
      bottom: 0
    },
    onFilter: text => onFilterByText(text, headerIndex)
  }));
}